package com.milta.core.auth

import com.milta.feature.auth.domain.entity.OAuthProvider

/**
 * Result of a native OAuth sign-in. [firstName]/[lastName] are best-effort: Google's ID token
 * carries them directly, but Apple only returns the user's name once, on the very first
 * authorization — on any later sign-in both are null and the finalize screen must let the user
 * type them manually (same as it already does for a phone number Apple/Google don't provide).
 */
data class OAuthSignInResult(
    val idToken: String,
    val firstName: String?,
    val lastName: String?,
    val email: String?,
)

interface OAuthSignInClient {
    suspend fun signIn(provider: OAuthProvider): OAuthSignInResult
}
